export default {
  name: '轮播图',
  imageTips: '最佳尺寸1366*584(PC)，375*500(Mobile)',
  btn: {
    searchJob: '搜索职位'
  },
  placeHolder: {
    enterModuleName: '请输入模块名称',
    enterJobKeywords: '请输入职位关键字'
  },
  label: {
    moduleName: '模块名称',
    showSearchBox: '显示搜索框',
    bgImageHeight: '背景',
    bgImage: '背景图片',
    imageHeight: '图片高度',
    imageWidth: '图片宽度',
    switchInterval: '切换间隔',
    microsecond: '毫秒（ms）'
  },
  radio: {
    show: '显示',
    hide: '不显示'
  }
}
